import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

import { BreadCrumbs } from "../common/layout";
import useApi from "../../hooks/useApi";
import prospectService from "../../services/prospectService";
import LoadingSpinner from "../common/loaders/loadingSpinner";

function VerifyContacts() {
  const [file, setFile] = useState(null);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [verifyType, setVerifyType] = useState("all");

  const verifyContactsApi = useApi(prospectService.verifyContacts);

  const handleUpload = async () => {
    if (!file) {
      toast.error("Please select an Excel file");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file, file.name);
      formData.append("verify_type", verifyType);

      const response = await verifyContactsApi.request(formData);

      if (response?.data?.success) {
        toast.success(response.data.message || "Verification completed");
        setDownloadUrl(response.data.download_url || "");
      } else {
        toast.error(response?.data?.message || "Verification failed");
      }
    } catch (error) {
      toast.error("File upload failed");
    }
  };

  return (
    <>
      {verifyContactsApi.loading && <LoadingSpinner />}

      <Helmet>
        <title>Verify Contacts | {global.config.title}</title>
      </Helmet>

      <BreadCrumbs
        Header="Verify Contacts"
        activeModule="Verify Contacts"
        Route1="/dashboard"
        Label1="Dashboard"
      />

      <div className="card overflow-visible p-3">
        <div className="card-header">
          <h6>Verify Contacts</h6>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <label>Upload Excel File</label>

                <input
                  type="file"
                  className="form-control"
                  accept=".xls,.xlsx"
                  onChange={(e) => {
                    const selectedFile = e.target.files && e.target.files[0];

                    if (selectedFile) {
                      setFile(selectedFile);
                      setDownloadUrl("");
                    }
                  }}
                />
              </div>

              {file && (
                <div className="alert alert-light border mt-3">
                  <strong>Selected File:</strong> {file.name}
                </div>
              )}
            </div>

            <div className="col-lg-4">
              <div className="form-group">
                <label>Verify Against</label>

                <select
                  className="form-control"
                  value={verifyType}
                  onChange={(e) => {
                    setVerifyType(e.target.value);
                    setDownloadUrl("");
                  }}
                >
                  <option value="all">All</option>
                  <option value="entity">Entities</option>
                  <option value="prospect">Prospects</option>
                  <option value="introducer">Introducers</option>
                </select>
              </div>
            </div>
          </div>

          <div className="mt-3">
            <button
              type="button"
              className="btn btn-primary"
              disabled={verifyContactsApi.loading}
              onClick={handleUpload}
            >
              {verifyContactsApi.loading ? "Processing..." : "Upload & Verify"}
            </button>

            {downloadUrl && (
              <a
                href={downloadUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-success ml-2"
              >
                Download Verified Excel
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default VerifyContacts;